module.exports = __webpack_public_path__ + "static/media/20161251446149-46.616f471c.jpg";